import Card from "../Reusable/Card";
import APIS from "../../constant/EndPoint";
import { Link } from "react-router-dom";
import usePostHook from "../../customHooks/usePostHook";

//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { Switch } from "@headlessui/react";
import React, { useEffect, useState } from "react";

type Props = {
  value: boolean;
  onChange: any;
  disabled?: boolean;
};

const UnControlSwitch = (props: Props) => {
  const { value, onChange, disabled = false } = props;
  const [enabled, setEnabled] = useState<boolean>(false);

  const handleToggle = (e: any) => {
    setEnabled((prev: boolean) => !prev);
    onChange(e);
  };

  useEffect(() => {
    if (value) {
      setEnabled(value);
    }
  }, [value]);

  return (
    <>
      <Switch
        checked={enabled}
        onChange={(e: any) => handleToggle(e)}
        disabled={disabled}
        className={tw`${enabled ? tw`bg-primary` : tw`bg-gray-300`}
          relative inline-flex h-5 w-8 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
      >
        <span className={tw`sr-only`}>Use setting</span>
        <span
          aria-hidden="true"
          className={tw`${enabled ? tw`translate-x-3` : tw`translate-x-0`}
            pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
        />
      </Switch>
    </>
  );
};

const MerchantUserProfile = (props: any) => {
  const { profile } = props;

  const { mutateAsync } = usePostHook({
    queryKey: ["."],
    navigateURL: "",
  });

  const handleUserStatusChange = async () => {
    const url = `${APIS.USER}${profile?.user}/change-active-status/`;
    let formData = {};
    try {
      await mutateAsync({ url, formData });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <Card>
        <div className={tw`m-2`}>
          <table>
            <tbody>
              <tr>
                <td>Name</td>
                <td>:</td>
                <td>{profile?.name ?? profile?.full_name ?? "N/A"}</td>
              </tr>
              <tr>
                <td>Email</td>
                <td>:</td>
                <td>{profile?.user_info?.email ?? profile?.email ?? "N/A"}</td>
              </tr>
              <tr>
                <td>Contact Number</td>
                <td>:</td>
                <td>{profile?.user_info?.mobile_number ?? "N/A"}</td>
              </tr>
            </tbody>
          </table>
          <div className={tw`w-full flex justify-between`}>
            <div className={tw`w-[150px] mt-6`}>
              <Link to={`/users/edit/${profile?.user}`}>Edit</Link>
            </div>
            <div>
              <UnControlSwitch
                value={profile?.user_info?.is_active}
                onChange={handleUserStatusChange}
              />
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};

export default MerchantUserProfile;
